export const replaceItemRecipe =
  <T, K extends keyof T>(key: K, value: T[K], data: T) =>
  (draft: T[]): T[] => {
    const index = draft?.findIndex((item) => item[key] === value) ?? -1;
    if (index > -1) {
      draft[index] = data;
    }
    return draft;
  };
